/* =====================================================================
   AA SOCIAL PROOF ENGINE  —  assets/aa-proof-engine.js
   STANDALONE asset. Loaded by the "Social Proof Ribbon" section ONLY
   when the toggle is on. Self-contained (IIFE) — it does NOT touch
   custom.js and cannot affect any existing feature.
   Renders the living proof ribbon: live stats + real 5-star quotes,
   scrolling (always one line, every device). Lazy, fail-soft, cached.
   ===================================================================== */
(function () {
  'use strict';

  var AA_PROOF = {
    SUPABASE_URL: 'https://ksnfxryxrlmabxpuozaq.supabase.co',
    ANON_KEY:     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtzbmZ4cnl4cmxtYWJ4cHVvemFxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MjAzNjEsImV4cCI6MjA4ODE5NjM2MX0.H0zoDHoSqwKoogQCBiLFeXWrG_Nuj1spk_0xGs-cw7c',
    BRAND:        'awareness_avenue',
    PUBLIC_STORE_ID:'VyYyho4tN.ad44ab23514def8b73fc607fa57e0db4def9b1db969b59f7d083c7271b10bd85',
    LOOX_REVIEWS_URL:'https://storefront-api.loox.io/storefront/v1/store/',
    CACHE_TTL_MS: 6 * 60 * 60 * 1000,
    OBSERVE_MARGIN:'300px',
    SCROLL_PX_PER_SEC: 45
  };
  if (!AA_PROOF.ANON_KEY || AA_PROOF.ANON_KEY.indexOf('PASTE') !== -1) return;

  var mem = {};
  function cacheGet(k){ if(mem[k]!==undefined)return mem[k];
    try{var r=sessionStorage.getItem(k); if(!r)return null; var o=JSON.parse(r);
      if(Date.now()-o.t>AA_PROOF.CACHE_TTL_MS)return null; mem[k]=o.v; return o.v;}catch(e){return null;} }
  function cacheSet(k,v){ mem[k]=v; try{sessionStorage.setItem(k,JSON.stringify({t:Date.now(),v:v}));}catch(e){} }
  function rpc(fn,args){
    var k='aaproof:'+fn+':'+JSON.stringify(args||{}); var hit=cacheGet(k);
    if(hit!==null) return Promise.resolve(hit);
    return fetch(AA_PROOF.SUPABASE_URL+'/rest/v1/rpc/'+fn,{
      method:'POST',
      headers:{'apikey':AA_PROOF.ANON_KEY,'Authorization':'Bearer '+AA_PROOF.ANON_KEY,'Content-Type':'application/json'},
      body:JSON.stringify(args||{})
    }).then(function(r){return r.ok?r.json():Promise.reject(r.status);})
      .then(function(d){cacheSet(k,d);return d;});
  }

  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){
    return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];});}
  function activeLocale(){
    var raw=String(document.documentElement.lang||(window.Shopify&&window.Shopify.locale)||'en').replace('_','-');
    var lower=raw.toLowerCase();
    if(lower==='pt-br') return 'pt-BR';
    if(lower==='zh-tw'||lower==='zh-hk') return 'zh-TW';
    if(lower==='zh-cn'||lower==='zh-sg') return 'zh-CN';
    var base=lower.split('-')[0];
    return base||'en';
  }
  var DEFAULT_COPY={reviews:'Reviews',countries:'Countries',ratedFourPlus:'Rated 4 Stars or Higher'};
  var localePromises={};
  function localeBundle(locale){
    if(localePromises[locale]) return localePromises[locale];
    localePromises[locale]=rpc('aa_social_proof_locale_bundle',{p_brand:AA_PROOF.BRAND,p_locale:locale})
      .catch(function(){return{requested_locale:locale,resolved_locale:'en',fallback:locale!=='en',copy:DEFAULT_COPY};});
    return localePromises[locale];
  }
  function warn(surface,locale,type,id,code){
    rpc('aa_record_social_proof_warning',{
      p_brand:AA_PROOF.BRAND,p_surface:surface,p_locale:locale,p_content_type:type,
      p_content_id:String(id||'unknown').slice(0,160),p_warning_code:code
    }).catch(function(){});
  }
  function localizedNumber(v,locale,digits){
    try{return new Intl.NumberFormat(locale,{minimumFractionDigits:digits,maximumFractionDigits:digits}).format(v);}
    catch(e){return digits?(Math.round(v*10)/10).toFixed(1):String(Math.round(v));}
  }
  function fmt(v,f,locale){
    if(f==='dec1') return localizedNumber(v,locale,1);
    if(f==='pct1') return localizedNumber(v,locale,1)+'%';
    return localizedNumber(Math.round(v),locale,0);
  }
  function compactCount(n,locale){
    if(n==null)return'';
    if(n<1000)return localizedNumber(n,locale,0);
    return localizedNumber(Math.floor(n/1000)*1000,locale,0)+'+';
  }
  var LANGUAGE_SIGNALS={
    fr:/\b(le|la|les|de|des|du|un|une|et|est|tr[eè]s|elle|il|je|ma|mon|mes|cette|ce|pour|avec|dans|que|pas|bien|belle|magnifique|bague|merci|adore|tout|fait|nous|vous)\b/i,
    de:/\b(der|die|das|den|dem|ein|eine|einen|und|ist|war|sehr|sie|er|ich|mein|meine|mit|f[uü]r|zu|von|auf|nicht|danke|sch[oö]n|wundersch[oö]n|liebt|alles)\b/i,
    es:/\b(el|la|los|las|de|del|un|una|y|es|fue|muy|ella|[eé]l|yo|mi|con|para|por|que|no|anillo|gracias|hermosa|precioso|encanta|todo)\b/i,
    ja:/[\u3040-\u30ff\u3400-\u9fff]/,
    nl:/\b(de|het|een|en|is|was|erg|heel|zij|hij|ik|mijn|met|voor|van|op|niet|bedankt|mooi|prachtig|houdt|alles)\b/i
  };
  function isLocalizedQuote(body,sourceLocale,targetLocale){
    if(targetLocale==='en'||sourceLocale===targetLocale)return true;
    var re=LANGUAGE_SIGNALS[targetLocale];if(!re)return false;
    if(targetLocale==='ja')return re.test(body);
    var hits=body.match(new RegExp(re.source,'gi'))||[], seen={};
    for(var i=0;i<hits.length;i++)seen[hits[i].toLowerCase()]=1;
    return Object.keys(seen).length>=2;
  }
  function looxHighlights(locale){
    var k='aaproof:loox:'+locale+':v4', hit=cacheGet(k);
    if(hit!==null) return Promise.resolve(hit);
    var url=AA_PROOF.LOOX_REVIEWS_URL+encodeURIComponent(AA_PROOF.PUBLIC_STORE_ID)
      +'/product-reviews?limit=100&rating=5&locale='+encodeURIComponent(locale);
    return fetch(url,{headers:{'Accept':'application/json'}})
      .then(function(r){return r.ok?r.json():Promise.reject(r.status);})
      .then(function(d){
        var rows=(d&&d.reviews)||[], out=[], seen={};
        for(var i=0;i<rows.length&&out.length<24;i++){
          var body=String(rows[i].body||'').replace(/\s+/g,' ').trim();
          var sourceLocale=String(rows[i].originalLanguage||'').toLowerCase().split('-')[0];
          var reviewer=rows[i].reviewer&&rows[i].reviewer.name;
          var quoteKey=body.toLowerCase();
          if(isLocalizedQuote(body,sourceLocale,locale)&&body.length>=12&&body.length<=90&&reviewer&&!seen[quoteKey]){
            seen[quoteKey]=true;
            out.push({reviewer:reviewer,quote:body,rating:rows[i].rating});
          }
        }
        cacheSet(k,out);
        return out;
      });
  }
  function initials(name){
    var p=String(name||'').trim().split(/\s+/); if(!p[0])return '\u2605';
    return (p[0].charAt(0)+(p.length>1?p[p.length-1].charAt(0):'')).toUpperCase();
  }
  function statItem(s){
    return '<span class="aa-ribbon__stat">'
      +'<span class="aa-ribbon__num">'+esc(s.num)+'</span>'
      +(s.star?'<span class="aa-ribbon__star" aria-hidden="true">\u2605</span>':'')
      +'<span class="aa-ribbon__lbl">'+esc(s.lbl)+'</span></span>'
      +'<span class="aa-ribbon__dot" aria-hidden="true"></span>';
  }
  function revItem(r){
    return '<span class="aa-ribbon__rev">'
      +'<span class="aa-ribbon__mono" aria-hidden="true">'+esc(initials(r.reviewer))+'</span>'
      +'<span class="aa-ribbon__stars" aria-hidden="true">\u2605\u2605\u2605\u2605\u2605</span>'
      +'<span class="aa-ribbon__q">\u201C'+esc(r.quote)+'\u201D</span>'
      +'<span class="aa-ribbon__nm">'+esc(r.reviewer)+'</span></span>'
      +'<span class="aa-ribbon__dot" aria-hidden="true"></span>';
  }

  var renderers = {
    ribbon: function(el){
      var locale=activeLocale();
      var src = (window.__aaProof && window.__aaProof.then)
        ? window.__aaProof
        : rpc('aa_proof_ribbon',{p_brand:AA_PROOF.BRAND, p_limit:24});
      return Promise.all([
        localeBundle(locale),
        src,
        looxHighlights(locale).catch(function(){return[];})
      ]).then(function(results){
        var bundle=results[0]||{}, labels=Object.assign({},DEFAULT_COPY,bundle.copy||{});
        var p=results[1]||{}, d=p.stats, revs=results[2]||[];
        if(bundle.fallback) warn('ribbon',locale,'ui_copy','ribbon','unsupported_locale');
        if(!revs.length&&locale==='en') revs=(p.highlights||[]);
        if(!revs.length&&locale!=='en'){
          revs=(p.highlights||[]);
          warn('ribbon',locale,'review_quote','ribbon-highlights','missing_translation');
        }
        if(!d) throw 'no-data';
        var stats=[
          {num:fmt(d.avg_rating,'dec1',locale), star:true,  lbl:compactCount(d.review_count,locale)+' '+labels.reviews},
          {num:String(d.countries),               star:false, lbl:labels.countries},
          {num:fmt(d.pct_4_plus,'pct1',locale),  star:false, lbl:labels.ratedFourPlus}
        ];
        var items=[], si=0;
        if(revs.length){
          for(var i=0;i<revs.length;i++){
            items.push(revItem(revs[i]));
            if(i%2===1){items.push(statItem(stats[si%stats.length]));si++;}
          }
        }else{
          for(var j=0;j<6;j++) items.push(statItem(stats[j%stats.length]));
        }
        var unit=items.join('');
        el.innerHTML='<div class="aa-ribbon"><div class="aa-ribbon__track">'+unit+unit+'</div></div>';
        var track=el.querySelector('.aa-ribbon__track');
        var half=track.scrollWidth/2;
        if(half>0) track.style.animationDuration=Math.max(20,Math.round(half/AA_PROOF.SCROLL_PX_PER_SEC))+'s';
        el.setAttribute('data-aa-state','ready');
      });
    }
  };

  function hydrate(el){
    var fn=renderers[el.getAttribute('data-aa-proof')]; if(!fn) return;
    el.setAttribute('data-aa-state','loading');
    fn(el).catch(function(){
      el.setAttribute('data-aa-state','warning');
      warn('ribbon',activeLocale(),'source','ribbon','source_fetch_failed');
    });
  }
  function init(){
    var nodes=document.querySelectorAll('[data-aa-proof]:not([data-aa-state])'); if(!nodes.length) return;
    if(!('IntersectionObserver' in window)){ Array.prototype.forEach.call(nodes,hydrate); return; }
    var io=new IntersectionObserver(function(entries,obs){
      entries.forEach(function(en){ if(en.isIntersecting){ obs.unobserve(en.target); hydrate(en.target); } });
    },{rootMargin:AA_PROOF.OBSERVE_MARGIN});
    Array.prototype.forEach.call(nodes,function(n){io.observe(n);});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  window.AAProof={init:init,rpc:rpc,locale:activeLocale,localeBundle:localeBundle,warn:warn,looxHighlights:looxHighlights};
})();
